import { useState, useEffect } from "react";
import { TbClockCancel } from "react-icons/tb";
import {
  Container,
  Stack,
  InputGroup,
  Form,
  FloatingLabel,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal
} from "react-bootstrap";
import Fecha from "./Fecha";
import { getMotivosEstudiante } from "../../services/apis_estudiante";

const styles = {
  comentario: {
    borderColor: "var(--color-primary) !important",
    backgroundColor: "var(--color-background)",
  },
  atencion: {
    borderColor: "var(--color-primary) !important",
    backgroundColor: "var(--color-background-3)",
  },
};

function ComentarioNuevo({ atencion, handleFinalizarAtencion, handleDescartar }) {
  const [comentario, setComentario] = useState("");
  const [motivos, setMotivos] = useState([]);
  const [motivoSeleccionado, setMotivoSeleccionado] = useState();
  const [showDescartarModal, setShowDescartarModal] = useState(false);

  // Traemos los motivos al cargar el componente
  useEffect(() => {
    async function fetchMotivos() {
      const lista = await getMotivosEstudiante();
      setMotivos(lista);

      // Buscar el motivo cuyo nombre coincide con atencion.motivo
      const motivoInicial = lista.find((m) => m.nombre === atencion.motivo);

      // Si lo encuentra, setea su ID como seleccionado
      if (motivoInicial) {
        setMotivoSeleccionado(motivoInicial.id);
      }
    }

    fetchMotivos();
  }, []);


  const handleComentarioChange = (event) => {
    setComentario(event.target.value);
  };

  const handleMotivoChange = (e) => {
    setMotivoSeleccionado(Number(e.target.value)); // Convierte el id a número
  };

  // const handleSaveComment = () => {
  //   // Llamamos a handleSubmit con comentario y motivo seleccionado
  //   handleSubmit(comentario, motivoSeleccionado);
  // };

  const handleDescartarClick = () => {
    setShowDescartarModal(true);
  };

  const confirmDescartar = () => {
    setShowDescartarModal(false);
    if (handleDescartar) {
      handleDescartar();
    }
  };

  const cancelDescartar = () => {
    setShowDescartarModal(false);
  };

  return (
    <div className="p-3 rounded border" style={styles.atencion}>
      <Stack gap={2}>
        <Stack direction="horizontal" gap={2}>
          <div className="me-auto">
            <Form.Select
              value={motivoSeleccionado}
              onChange={handleMotivoChange}
              size="sm"
            >
              {motivos.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.nombre}
                </option>
              ))}
            </Form.Select>
          </div>
          <OverlayTrigger
            placement="top"
            trigger={["hover"]}
            delay={{ show: 1000, hide: 0 }}
            overlay={
              <Tooltip className="tooltip-ficha">Usuario no apareció</Tooltip>
            }
          >
            <Button variant="secondary" onClick={handleDescartarClick}>
              <TbClockCancel className="me-1" /> Descartar
            </Button>
          </OverlayTrigger>
          <Button
            size="md"
            variant="danger"
            type="button"
            onClick={() =>
              handleFinalizarAtencion(comentario, motivoSeleccionado)
            }
          >
            Finalizar Atención
          </Button>
        </Stack>

        <Form.Control
          as="textarea"
          placeholder="Ingrese comentario aquí"
          style={{ height: "100px" }}
          value={comentario}
          onChange={handleComentarioChange}
        />
      </Stack>

      {/* Modal de confirmación para descartar */}
      <Modal show={showDescartarModal} onHide={cancelDescartar} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Descarte</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Está seguro que desea descartar esta atención? Esta acción no se
          puede deshacer.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDescartar}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmDescartar}>
            Descartar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ComentarioNuevo;
